import React from 'react'
import { Row, Col, Form, Select, Radio, Table, Spin, Button } from 'antd'
import Layouts from '../components/Layouts'
import { useState, useEffect } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { useHistory } from 'react-router-dom';
import apiRequest from '../hooks/apiRequest'
import { toast } from 'react-toastify'
import ClaimCreation from '../ClaimCreation'
const { Option } = Select
function InitiateClaim(props) {
  const [obj, setObj] = useState({
    insurerId: '',
  })
  const productID = Number(localStorage.getItem('productId'))
  const [lossDate, setlossDate] = useState(new Date())
  const [radiovalue, setValue] = React.useState(productID)
  const [searchData, setSearchData] = useState([])
  const [policydetail, setpolicydetail] = useState()
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState()
  const [policyNumber, setPolicyNumber] = useState()
  const [startDate, setStartDate] = useState()
  const [paymentStatus, setPaymentStatus] = useState([])
  const [productId, setProductId] = useState()
  const [paymentOTMstatus, setpaymentOTMstatus] = useState()
  const [productList, setProductList] = useState([])
  const [customerDetail, setCustomerDetail] = useState()
  const [emailBody, setEmailBody] = useState()
  const history = useHistory();
  const loggedInUserID = localStorage.getItem('loggedInUserID');
  const loggedInUserName = localStorage.getItem('username');

  const onMotorChange = e => {
    setValue(e.target.value)
    setProductId(e.target.value)
    setSearchData([])
  }
  const onhandleChange = async val => {
    setLoading(true)
    let policyData
    let fetchURL = ''
    debugger;
    if (radiovalue !== 6 && !val.includes('OTM')) {
      // fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${val},${productId}`;
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybyPolicyId/${val}`
    } else if (radiovalue === 6 && val.includes('OTM')) {
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/OTM/Policy/${val}`
    }

    try {
      const response = await apiRequest(fetchURL, 'GET')
      if (response.success) {
        const data = response.data
        if (radiovalue !== 6 && !val.includes('OTM')) {
          setStartDate(data.policydetail.policystartdate)
          setPolicyNumber(data.policydetail.policynumber)
          setPaymentStatus(data.payment_detail)
          setEmailBody(data)
          setObj({ insurerId: data?.policydetail?.insurerId })
          const policy_info = data.policydetail.ipolicyInfo
          const extracted_policy_info = JSON.parse(policy_info)
          const quotation_info = JSON.parse(
            extracted_policy_info.IquotationInfo,
          )
          const email_body = {
            customerDetail: {
              customerId: quotation_info.customerid,
              notifyCustomer: quotation_info.customeremail,
            },
            insurerDetail: {
              insurerId: quotation_info.InsurerId,
              notifyInsurer: data.email,
            },
            brokerDetail: {
              brokerId: quotation_info.createdby,
              notifyBroker: quotation_info.BrokerEmail,
            },
          }

          setEmailBody(JSON.stringify(email_body))
          policyData = {
            customerName: data.policydetail.customername,
            policyNo: data.policydetail.policynumber,
            startDate: data.policydetail.policystartdate,
            endDate: data.policydetail.policyexpirytdate,
            premium: data.policydetail.grandtotaltermpremium,
            annualPremium: data.policydetail.grandtotalannualpremium,
            vrn: '',
            riskItemDetails: data.policydetail.riskitemdetails,
            sumInsured: data.policydetail.totalSumInsured,
            policyNumber: data?.policydetail?.policynumber,
            customerEmail: data?.customerdetail.clientemailaddress,
          }

          const itemNames = data.policydetail.riskitemdetails.map(
            item => item.riskitemname,
          )
          setItems(itemNames)
        } else if (radiovalue === 6 && val.includes('OTM')) {
          policyData = {
            customerName: `${data.first_name} ${data.surname}`,
            policyNo: data.policy_number,
            startDate: data.policy_start_date,
            endDate: data.policy_end_date,
            premium: data.premium,
            vrn: data.vrn,
            riskItemDetails: '',
            sumInsured: data.sum_insured,
            policyNumber: data?.policydetail?.policynumber,
            customerEmail: data.clientemailaddress,
          }

          setpaymentOTMstatus(data.payment_status.toLowerCase())
          setItems('')
        }
        debugger;

        setCustomerDetail(data.customerdetail)
        setpolicydetail(policyData)
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Error fetching policy data:', error)
    } finally {
      setLoading(false)
    }
  }
  const onSearch = async value => {
    if (!value || value.length === 0) return

    try {
      if (radiovalue !== 6 && !value.includes('OTM')) {
        // const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value},${productId}`;
        const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          setSearchData(response.data)
        } else {
          console.error('Search failed:', response.error)
        }
      } else if (radiovalue === 6 && value.includes('OTM')) {
        const url = `http://64.227.72.205:5001/api/v1/policy/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          const data = response.data
          setSearchData([
            {
              policynumber: data.policy_number,
              nationalid: data.id_number,
              customername: `${data.first_name} ${data.surname}`,
            },
          ])
        } else {
          console.error('OTM policy search failed:', response.error)
        }
      }
    } catch (error) {
      console.error('Unhandled error in onSearch:', error)
    }
  }

  const options = searchData.map(d => (
    <Select.Option key={d.policyid}>
          {d.policynumber} - {d.customername} - {d.productname}
    </Select.Option>
  ))
  const columns = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Stamp Duty',
      render: x => '$' + x.stampdutytermpremium,
      key: '3',
    },
    {
      title: 'Term Premium',
      render: x => '$' + x.termpremium,
      key: '3',
    },
    {
      title: 'Total Term Premium',
      render: x => '$' + (parseFloat(x.termpremium) + parseFloat(x.stampdutytermpremium)),
      key: '4',
    },
  ]
  const columnsFCP = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Monthly Premium',
      render: x => x.monthlypremium,
      key: '4',
    },
  ]
  const fetchData = async () => {
    const List = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
    )
    console.log(List?.data)
    setProductList(List?.data?.data)
  }

  useEffect(() => {
    fetchData()
  }, [])

  // Send Mail To client for add detail
  const handleSubmit = async () => {
    debugger;
    setLoading(true)
    const url = `${process.env.REACT_APP_BASE_URL}/Claim/SendClaimRequest/send-claim-request`
    const payload = {
      toEmail: customerDetail?.clientemailaddress,
      policyNumber: policydetail.policyNumber,
      Claimnumber: policydetail.Claimnumber,
      type: 'Broker',
      BrokerId: loggedInUserID,
      BrokerName: loggedInUserName,
    }
    console.log('payload', payload)
    try {
      const res = await apiRequest(url, 'POST', payload)
      if (res.success) {
        toast.success('Email send sucessfully');
        history.push('/claims');
      } else {
        toast.error(res.error || 'Something went wrong')
      }
    } catch (err) {
      console.error('Submit error:', err)
      // toast.error('Request failed, try again.')
    } finally {
      setLoading(false)
    }
  }
  return (
    <Layouts title="assets" classname="grid">
      <Spin
        className="loader-icon-fixed"
        spinning={loading}
        size="large"></Spin>
      <div>
        <div style={{ padding: '10px' }}>
          <div className="align-right">
            <Row gutter={4}>
              <Col xs={12} sm={24} md={12} lg={24}>
                {/* <Radio.Group
                  onChange={onMotorChange}
                  value={radiovalue}
                  style={{margin: '0px 0px 10px 0px'}}>
                  {productList &&
                    productList?.map(elem => (
                      <Radio value={elem?.productid}>{elem?.productname}</Radio>
                    ))}
                </Radio.Group>{' '} */}
                <Select
                  className="ant-input-bx"
                  showSearch
                  placeholder="Search Policy..."
                  // style={this.props.style}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={onSearch}
                  onChange={onhandleChange}
                  notFoundContent={null}>
                  {options}
                </Select>
              </Col>
            </Row>
          </div>
        </div>

        <div>
          <div className=" dash-bg-white">
            <h2
              style={{
                color: '#F15A2B',
                fontWeight: '500',
                fontSize: '20px',
                marginBottom: '15px',
              }}>
              <strong>
                Policy Details{' '}
                <label
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                  }}></label>
              </strong>
            </h2>
            {policydetail ? (
              <>
                <Row gutter={[16, 16]} align="middle">

                  {/* Column 1 */}
                  <Col xs={24} md={12} lg={6}>
                    <div><b>Customer Name :</b> {policydetail?.customerName}</div>
                    <div><b>Customer Email :</b> {policydetail?.customerEmail}</div>
                  </Col>

                  {/* Column 2 */}
                  <Col xs={24} md={12} lg={6}>
                    <div><b>Policy No :</b> {policydetail?.policyNo}</div>
                    <div><b>Payment Status :</b> {paymentStatus?.payment_status ?? "Unpaid"}</div>
                  </Col>

                  {/* Column 3 */}
                  <Col xs={24} md={12} lg={6}>
                    <div><b>Annual Premium :</b> ${policydetail?.annualPremium}</div>
                    <div><b>Sum Insured :</b> ${policydetail?.sumInsured}</div>
                  </Col>

                  {/* Column 4 */}
                  <Col xs={24} md={12} lg={6}>
                    <div><b>Start Date :</b> {policydetail?.startDate}</div>
                    <div><b>End Date :</b> {policydetail?.endDate}</div>
                  </Col>

                </Row>
                {policydetail && !policydetail.policyNo.includes('OTM') && (
                  <div className="table-grid-bx" style={{ marginTop: '20px' }}>
                    <Table
                      columns={
                        policydetail.policyNo.includes('OTFCP')
                          ? columnsFCP
                          : columns
                      }
                      dataSource={policydetail && policydetail.riskItemDetails}
                      scroll={{ x: 768 }}
                      pagination={false}
                    />
                  </div>
                )}
                <br />
                {paymentStatus?.payment_status?.toLowerCase() !== "unpaid" && (
                  <Button onClick={() => handleSubmit()} className='send-mail-btn'>
                    Send Mail
                  </Button>
                )}

              </>
            ) : <div><strong>Search Policy....</strong></div>}
          </div>
        </div>
      </div>
    </Layouts>
  )
}

export default InitiateClaim
